import React, { useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import gsap from "utils/gsap";
import StatCard from "./StatCard";

const StatCardGroup = ({ items }) => {
  const groupRef = useRef(null);

  useEffect(() => {
    if (!groupRef.current) return;

    const cards = groupRef.current.querySelectorAll(".stat_card");

    gsap.fromTo(
      cards,
      {
        opacity: 0,
        y: 16,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.25,
        ease: "power2.out",
        stagger: 0.08,
      }
    );
  }, []);

  return (
    <Row className="g-3 mb-1" ref={groupRef}>
      {items.map((item) => (
        <Col xl={3} lg={6} md={6} key={item.id}>
          <StatCard {...item} />
        </Col>
      ))}
    </Row>
  );
};

export default StatCardGroup;
